type HeadProps = {
  title?: string;
  description?: string;
};

const Head = ({ title = '', description = '' }: HeadProps = {}) => {
  const fullTitle = title ? `${title} | SCL` : 'SCL';

  return (
    <>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
    </>
  );
};

export { Head };
